import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

// import {AddFabButtonComponent} from '@shared/components/add-fab-button/add-fab-button.component';
import {PipeModule} from '@shared/pipes/pipe.module';
import {ZorroModule} from '@shared/zorro.module';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';
// import {MatButtonModule} from '@angular/material/button';
// import {MatIconModule} from '@angular/material/icon';
import {LazyImageDirective} from '@shared/directives/lazy-image.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ZorroModule,
    PipeModule
    // MatButtonModule,
    // MatIconModule,
  ],
  declarations: [
    // AddFabButtonComponent,
    LazyImageDirective],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ZorroModule,
    // AddFabButtonComponent,
    PipeModule,
    LazyImageDirective
  ],
  providers: [
    ThemeConstantService
  ]
})
export class SharedModule {
}
